module.exports = __webpack_public_path__ + "static/freshdesk-bf8df5f9093c7ba1a9bf27998bd4dd05.svg";